export default __webpack_public_path__ + "static/media/ios.cca788dc.svg";